import { claimApi } from 'store/baseApi';

export const getPerils = (policyId: string) =>
  claimApi.get(`policies/${policyId}/perils`);

const api = { getPerils };

export default api;
